// OpenDefaultInpFileHeadless.tsx
import { useEffect } from "react"
import "./index.css"
import { parseInput } from "./swmmjs_module.js"

const OpenDefaultInpFileHeadless = ({setModel, fileNames}:any) => {
  async function showFile () {
    // Read the input file
    fetch(fileNames[0])
      .then((r)=>r.text())
      .then(text =>{
        let jsonSWMM = parseInput(text)
        setModel(jsonSWMM)
      })
  }

  useEffect(()=>{
    showFile()
  }, [])

  return(
    null
  )
}
 
export {OpenDefaultInpFileHeadless}